<template>
  <div>
    <el-checkbox-group v-model="checkList">
      <p v-for="temp in lines" :key="'temp' + temp" class="temp">
        <el-checkbox :label="2 ** (temp - 1)" @change="tempSetCheck"
          >{{ temp }}路</el-checkbox
        >
      </p>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "tempCheck",
  data() {
    return {
      checkList: []
    };
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    lines: {
      type: Number,
      default: 4
    }
  },
  watch: {
    value: {
      handler() {
        this.checkList = [];
        for (let i = 0; 2 ** i <= this.value; i++) {
          if (((2 ** i) & this.value) === 2 ** i) {
            this.checkList.push(2 ** i);
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    tempSetCheck() {
      console.log(this.checkList);
      let num = this.checkList.reduce((pre, cur) => {
        return pre + cur;
      });
      console.log(num);
      this.$emit("input", num);
    }
  }
};
</script>

<style lang="scss" scoped>
.temp {
  float: left;
  width: 25%;
  margin: 5px 0;
}
</style>
